// extracted by mini-css-extract-plugin
export var card = "_4z-0";
export var content = "_4z-1";
export var contentLoading = "_4z-2";